import {
  formatAmount,
  formatCurrency,
  getCurrencyCode,
  getCurrencySymbol,
} from '@/utils/currency'

/**
 * Валюта страны инстанса для шаблонов и методов компонентов:
 * `$currency.symbol` (₽/₮), `$currency.code` (RUB/MNT), `$currency.format(сумма)`.
 * Страна берётся из `DEFAULT_COUNTRY`, данные — из `locales/currencies.json`.
 */
export default function (context, inject) {
  inject('currency', {
    symbol: getCurrencySymbol(),
    code: getCurrencyCode(),
    format: formatCurrency,
    formatAmount,
  })
}
